export const secondary = {
  50: "#e3fcee", // very light
  100: "#bbf7dc",
  200: "#91efca",
  300: "#66e5b6",
  400: "#46dba7",
  500: "#1cd487", // base
  600: "#17b673",
  700: "#13985f",
  800: "#0f7a4b",
  900: "#085328", // very dark
};
